import { render } from "./GivingAmount.vue?vue&type=template&id=3bc8d044&scoped=true"
import script from "./GivingAmount.vue?vue&type=script&lang=js"
export * from "./GivingAmount.vue?vue&type=script&lang=js"

import "./GivingAmount.vue?vue&type=style&index=0&id=3bc8d044&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc8d044"]])

export default __exports__